module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('p', {
    staticClass: "better-menu-label fs-4 d-flex align-items-center mb-1"
  }, [_c('SharedWithUsersIcon', {
    staticClass: "mr-2",
    attrs: {
      "height": 20,
      "width": 21
    }
  }), _vm._v(" My Groups\n    "), _c('span', {
    staticClass: "my-tag"
  }, [_vm._v(_vm._s(_vm.filteredGroups.length))])], 1), _vm._v(" "), (_vm.filteredGroups.length > 8) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.groupQuery),
      expression: "groupQuery"
    }],
    staticClass: "input mt-1",
    attrs: {
      "type": "text",
      "placeholder": "Filter groups"
    },
    domProps: {
      "value": (_vm.groupQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.groupQuery = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('Loader') : _c('div', [(_vm.filteredGroups.length > 0) ? _c('ul', {
    staticClass: "menu-list scroll-container"
  }, _vm._l((_vm.filteredGroups), function(g) {
    return _c('li', [_c('router-link', {
      staticClass: "is-primary d-flex align-items-center flex-wrap break-word",
      attrs: {
        "to": '/groups/' + g.id
      }
    }, [_vm._v("\n\n          " + _vm._s(g.name) + "\n        ")])], 1)
  })) : _c('p', {
    staticClass: "text-muted italic p-2"
  }, [_vm._v("No groups")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-c2315dc2"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupsSection.vue
// module id = 1082
// module chunks = 0